/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect } from "react";
import { useTimer } from "react-timer-hook";
// import { type } from "../../pages/quiz/QuizRunner";
import { padStart } from "lodash";
// import { useState } from "react";

export function ReadingTimerCount({
  totalTimeInSeconds,
  data,
  onStop,
  data_section_id,
  data_exercise_id,
  // setShowTimeWarning,
  isStopTimer,
}) {
  // const [timerClass, setTimerClass] = useState();
  let options = {
    autoStart: true,
  };

  const localTime = new Date();
  let timer;
  timer = window.sessionStorage.getItem("readingtimer" + data.student_assessment_id + data_section_id + data_exercise_id)
  
  if (!timer){
    localTime.setSeconds(localTime.getSeconds() + parseInt((totalTimeInSeconds)));
  }
  else{
    localTime.setSeconds(localTime.getSeconds() + parseInt(timer));
  }
  

  if (localTime) {
    options = { ...options, expiryTimestamp: localTime };
  }
  const { seconds, minutes, pause, hours, } = useTimer(options);
  let spent_minutes = padStart([`${minutes}`], [2], ["0"]);
  let spent_seconds = padStart([`${seconds}`], [2], ["0"]);
  const storeInLocalStorage = useCallback(() => {
 
    const timeInSeconds = seconds + minutes * 60 + hours * 60 * 60;
    if (timeInSeconds <= "00") {
      onStop(timeInSeconds);
    }
    // if (timeInSeconds <= parseInt((5) * 60)) {
    //   setTimerClass("text-danger");
    //   // setShowTimeWarning(true);
    // }
    window.sessionStorage.setItem("readingtimer" + data.student_assessment_id + data_section_id + data_exercise_id, timeInSeconds);
    // window.sessionStorage.setItem("timer" + data.student_assessment_id, timeInSeconds);
  }, [minutes, seconds, hours, onStop, totalTimeInSeconds]);

  useEffect(() => {
    storeInLocalStorage();
  }, [storeInLocalStorage]);

  useEffect(() => {
    if (isStopTimer) {
      pause();
    }
  }, [isStopTimer, pause]);

  return (
    <div className={`inline`}>
      <b>
        <svg
            width="22"
            height="24"
            viewBox="0 0 22 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
          <path
          d="M11 5V11L15 13M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
          stroke="black"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          />
        </svg>
        <span className="ps-2 fs-8">
        <span className="text-dark">Reading Time: </span> <span>{spent_minutes}</span>:<span>{spent_seconds}</span>
        </span>
      </b>
    </div>
  );
}
